import { Injectable, Injector } from '@angular/core';

import { Session } from './session';

import { trackPageView, setDimensions } from '../lib/google-analytics';

import { isProduction } from '../lib/environments.const';
import { isPublicUrlAccess } from '@lib/public-url-access';

@Injectable({ providedIn: 'root' })
export class Analytics {
  constructor(injector: Injector) {
    if (isProduction() && !isPublicUrlAccess()) {
      const session = injector.get(Session);
      setDimensions(session);
    }
  }

  public reportNavigation(routerPath) {
    if (isProduction()) {
      trackPageView(routerPath);
    }
  }
}
